import { Application } from "@hotwired/stimulus";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";
import slugify from "slugify";
import { ProgressRing, Reviews } from "./components";
import { checkSmileWidget } from "./helpers";
import { checkSmileCloseButton } from "./helpers";
import { enableBodyScroll, disableBodyScroll } from "body-scroll-lock-upgrade";
window.Stimulus = Application.start();

// Get all controllers and load them
const context = require.context("./controllers", true, /\.js$/);
Stimulus.load(definitionsFromContext(context));

// Slugify Config
slugify.extend({ "&": "", "/": "-" });

window.addEventListener("DOMContentLoaded", () => {
  // @TODO: Remove when wallpaper calculator gets refactored to the panel controller
  const pageLink = document.querySelector("button[data-target]");

  if (pageLink) {
    pageLink.addEventListener("click", (e) => {
      e.preventDefault();
      document
        .querySelector(`#${pageLink.dataset.target}`)
        .classList.add("expanded");
    });
  }

  const progressRing = document.querySelector(".progress-ring");
  if (progressRing) {
    ProgressRing(66);
  }

  if (
    !(
      window.location.pathname.includes("/collections/") ||
      window.location.pathname.includes("/products/")
    )
  ) {
    sessionStorage.removeItem("ref_id");
  }

  handleLinks();

  const handleWidgetZindex = (smileUI, smileButton, smileLauncherContainer) => {
    smileButton.addEventListener("click", () => {
      if (smileLauncherContainer.classList.contains("smile-launcher-open")) {
        smileUI.style.zIndex = 2147483647;
      }

      const handleCloseButton = (smileUI, smilePanelButton) => {
        smilePanelButton.addEventListener("click", () => {
          smileUI.style.zIndex = 9;
        });
      };
      checkSmileCloseButton(handleCloseButton);
    });
  };
  checkSmileWidget(handleWidgetZindex);

  const filterToggle = document.querySelector("#filter-tree-toggle");
  if (filterToggle) {
    filterToggle.addEventListener("change", () => {
      scrollLock(".filter-tree");
    });
  }

  const mobileMenuToggle = document.querySelector("#mobile-nav-toggle");

  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener("change", () => {
      const smileUIContainer = document.querySelector("#smile-ui-container");

      if (smileUIContainer) {
        if (mobileMenuToggle.checked) {
          smileUIContainer.style.zIndex = 9;
        } else {
          smileUIContainer.style.zIndex = 120;
        }
      }
    });
  }
});

if (window.location.pathname === "/cart") {
  window.addEventListener("scroll", () => {
    const footer = document.querySelector(".footer");
    const mobileAction = document.querySelector(".section-cart__mobile-action");
    const footerBounds = footer.getBoundingClientRect();

    if (mobileAction) {
      if (footerBounds.y <= 243) {
        mobileAction.style.position = "fixed";
        mobileAction.style.padding = "1.2rem 1.5rem 0";
      } else {
        mobileAction.style.removeProperty("position");
        mobileAction.style.removeProperty("padding");
      }
    }
  });

  // Handle Internal Links
  document.querySelectorAll("[data-href]").forEach((elem) => {
    elem.addEventListener("click", () => {
      window.location.href = elem.dataset.href;
    });
  });
}

const handleLinks = () => {
  document.querySelectorAll(".js-anchor").forEach((anchor) => {
    anchor.addEventListener("click", () => {
      const link = anchor.querySelector("a");
      if (link) {
        window.location.href = link.href;
      }
    });
  });
};

if (document.querySelector(".js-reviews")) {
  new Reviews();
}


// Temporary fix for the editorial hub
if (window.location.pathname == "/pages/editorial-hub") {
  setTimeout(() => {
    handleLinks();
  }, 1000);
}
